module.exports = __webpack_public_path__ + "img/id-card-alt.62b74bf8.svg";